import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import CreateLifeWheel from './components/CreateLifeWheel';
import ViewLifeWheel from './components/ViewLifeWheel';
import AdminView from './components/AdminView';
import AdminManagement from './components/AdminManagement';
import AdminProfile from './components/AdminProfile';
import API_BASE_URL from './config';
import './App.css';

function App() {
  const [adminRole, setAdminRole] = useState(null);
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const syncRole = () => {
      setAdminRole(localStorage.getItem('adminRole'));
      setIsAdminLoggedIn(Boolean(localStorage.getItem('adminToken')));
    };

    syncRole();
    window.addEventListener('admin-role-changed', syncRole);
    window.addEventListener('admin-auth-changed', syncRole);

    const token = localStorage.getItem('adminToken');
    if (token && !localStorage.getItem('adminRole')) {
      fetch(`${API_BASE_URL}/api/admin/me`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      })
        .then(async (response) => {
          const text = await response.text();
          const data = text ? JSON.parse(text) : null;
          if (!response.ok) {
            throw new Error(data?.error || 'Failed to fetch admin profile');
          }
          return data;
        })
        .then((data) => {
          if (data?.role) {
            localStorage.setItem('adminRole', data.role);
            setAdminRole(data.role);
          }
          setIsAdminLoggedIn(true);
        })
        .catch(() => {
          localStorage.removeItem('adminRole');
          setAdminRole(null);
          setIsAdminLoggedIn(Boolean(localStorage.getItem('adminToken')));
        });
    }

    return () => {
      window.removeEventListener('admin-role-changed', syncRole);
      window.removeEventListener('admin-auth-changed', syncRole);
    };
  }, []);

  const basePath = process.env.PUBLIC_URL || '';

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminRole');
    setAdminRole(null);
    setIsAdminLoggedIn(false);
    setMenuOpen(false);
    window.dispatchEvent(new Event('admin-auth-changed'));
    window.dispatchEvent(new Event('admin-role-changed'));
    window.location.assign(`${basePath}/admin`);
  };

  return (
      <Router basename={basePath}>
        <div className="container">
          <nav className="navigation">
            <a href="https://cco-toolkit.com/" className="nav-logo">
              <img src={process.env.PUBLIC_URL + '/CCO-Logo1.jpg'} alt="Life Wheel Logo" />
            </a>
            <div className="nav-center">
              <Link to="/" className="nav-link">Create Life Wheel</Link>
              <Link to="/view" className="nav-link">View Life Wheel</Link>
              {isAdminLoggedIn && (
                <Link to="/admin" className="nav-link">View All Wheels</Link>
              )}
            </div>
            <div className="nav-right">
              {isAdminLoggedIn && (
                <div
                  className={`user-menu${menuOpen ? ' open' : ''}`}
                  tabIndex={0}
                  onBlur={() => setMenuOpen(false)}
                >
                  <button
                    type="button"
                    className="user-button"
                    onClick={() => setMenuOpen((prev) => !prev)}
                    aria-haspopup="true"
                    aria-expanded={menuOpen}
                  >
                    <span className="user-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" width="18" height="18" focusable="false">
                        <path
                          fill="currentColor"
                          d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm0 2c-3.33 0-6 1.34-6 3v3h12v-3c0-1.66-2.67-3-6-3Z"
                        />
                      </svg>
                    </span>
                    <span className="user-label">Account</span>
                  </button>
                  <div className="user-dropdown">
                    <Link
                      to="/admin/profile"
                      className="dropdown-link"
                      onClick={() => setMenuOpen(false)}
                    >
                      Profile
                    </Link>
                    {adminRole === 'super_admin' && (
                      <Link
                        to="/admin/admins"
                        className="dropdown-link"
                        onClick={() => setMenuOpen(false)}
                      >
                        Manage Admins
                      </Link>
                    )}
                    <button type="button" className="dropdown-link dropdown-button" onClick={handleLogout}>
                      Logout
                    </button>
                  </div>
                </div>
              )}
            </div>
          </nav>

          <div className="content">
            <Routes>
              <Route path="/" element={<CreateLifeWheel />} />
              <Route path="/view" element={<ViewLifeWheel />} />
              <Route path="/view/:wheelId" element={<ViewLifeWheel />} />
              <Route path="/admin" element={<AdminView />} />
              <Route path="/admin/admins" element={<AdminManagement />} />
              <Route path="/admin/profile" element={<AdminProfile />} />
            </Routes>
          </div>
        </div>
      </Router>
  );
}

export default App;
